export enum ResponseType {
    Success,

    Fatal,

    ServiceUnavailable,

    InsufficientAuth,

    RequestError,
    Unauthorized,
    Forbidden,
    NotFound,
    Conflict,
    ServerError,
    UnknownError,
}
export type ResponseErrorTypes = ResponseType.RequestError |
    ResponseType.Unauthorized |
    ResponseType.Forbidden |
    ResponseType.NotFound |
    ResponseType.Conflict |
    ResponseType.ServerError |
    ResponseType.UnknownError;
